import { GetterTree } from "vuex";
import { IPermissionsState } from "@/core/interfaces/permissionsState.interface";
import {
  IPermission,
  IPermissionCategory,
} from "@/core/interfaces/permission.interface";
import { StoreState } from "@/store/type";

const getters: GetterTree<IPermissionsState, StoreState> = {
  isFetchingPermissions: (state): boolean => state.isFetchingPermission,
  systemPermissions: (state): Array<IPermission> => {
    return state.permissions;
  },
  permissionCategories: (state): Array<IPermissionCategory> => {
    return state.permissionCategories;
  },
};

export default getters;
